<template>
  <div class="app-activation-top-up">
    <div class="text"><slot name="txtBeforeTopUp"></slot></div>
    <b-form
      class="activation-top-up-form"
      :id="'form' + _uid"
      :novalidate="true">
    <activation-auto-top-up-wrapper
      :topUp.sync="autoTopUp"
      :monthly-value="monthlyValue"
    >
      <template #txtBeforeAutoTopUp><slot name="txtBeforeAutoTopUpWrapper"></slot></template>
      <template #lblWithoutAuto><slot name="lblWithoutAutoWrapper"></slot></template>
      <template #txtHeaderMonthlyAutoTopUp><slot name="txtHeaderMonthlyAutoTopUpWrapper"></slot></template>
      <template #lblMonthlyAutoTopUp><slot name="lblMonthlyAutoTopUpWrapper"></slot></template>
      <template #lblMonthlyAmountAutoTopUp><slot name="lblMonthlyAmountAutoTopUpWrapper"></slot></template>
      <template #txtHeaderByLimitAutoTopUp><slot name="txtHeaderByLimitAutoTopUpWrapper"></slot></template>
      <template #lblByLimitAutoTopUpFirst><slot name="lblByLimitAutoTopUpWrapperFirst"></slot></template>
      <template #lblByLimitAutoTopUpSecond><slot name="lblByLimitAutoTopUpWrapperSecond"></slot></template>
    </activation-auto-top-up-wrapper>
    <PaymentWrapper v-if="paymentRequired"
          :credit-card-redirect-url="creditCardRedirectUrl"
          :credit-card-frame-address="creditCardFrameAddress"
          :payment.sync="payment"
          :paymentInvalid.sync="paymentInvalid_"
          :payment-context="paymentContext"
          :process-name="'activation'"
    >
      <template #txtBeforePayment><slot name="txtPaymentBeforePayment"></slot></template>
      <template #lblCreditCard><slot name="lblPaymentCreditCard"></slot></template>
      <template #txtCcBefore><slot name="txtPaymentCcBefore"></slot></template>
      <template #txtCcInfoBefore><slot name="txtPaymentCcInfoBefore"></slot></template>
      <template #lblCcInfoCcHolder><slot name="lblPaymentCcInfoCcHolder"></slot></template>
      <template #lblCcInfoCcNumber><slot name="lblPaymentCcInfoCcNumber"></slot></template>
      <template #lblCcInfoCcType><slot name="lblPaymentCcInfoCcType"></slot></template>
      <template #lblCcInfoCcValidty><slot name="lblPaymentCcInfoCcValidty"></slot></template>
      <template #txtCcInfoAfter><slot name="txtPaymentCcInfoAfter"></slot></template>
      <template #txtCcInfoError><slot name="txtPaymentCcInfoError"></slot></template>
      <template #btnCcRestart><slot name="btnPaymentCcRestart"></slot></template>
      <template #txtCcAfter><slot name="txtPaymentCcAfter"></slot></template>
      <template #lblBankAccount><slot name="lblPaymentBankAccount"></slot></template>
      <template #lblBankAccountOwner><slot name="lblPaymentBankAccountOwner"></slot></template>
      <template #lblBankAccountIban><slot name="lblPaymentBankAccountIban"></slot></template>
      <template #txtBankAccountIbanLiveFeedback><slot name="txtPaymentBankAccountIbanLiveFeedback"></slot></template>
      <template #lblBankAccountPaymentConfirmation><slot name="lblPaymentBankAccountPaymentConfirmation"></slot></template>
    </PaymentWrapper>
      <b-button class="btn-back" variant="primary" type="button"  v-on:click="back">
        <slot name="btnBack">zurück</slot>
      </b-button>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button v-on:click="save" class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import ActivationAutoTopUpWrapper from './AutoTopUpWrapper.vue'
import PaymentWrapper from '../../../generic/Payment/PaymentCollection.vue'
import { validationMixin } from 'vuelidate'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { stepName as prevProcessStep } from '../Tariff/TariffOptions.vue'
import { stepName as nextProcessStep } from './ActivationSummaryWrapper.vue'
import processSteps from '@/mixins/processSteps'
import preFilledInput from '@/mixins/preFilledInput'
export const stepName = 'topUp'
export default {
  name: 'ActivationTopUp',
  data () {
    return {
      paymentInvalid_: true,
      loading: false
    }
  },
  mixins: [
    validationMixin,
    processSteps(stepName, prevProcessStep, nextProcessStep),
    preFilledInput('payment', 'storedPayment'),
    preFilledInput('autoTopUp', 'storedTopUp')
  ],
  validations () {
    return {
      paymentInvalid_: {
        validPaymentIfRequired: (value, vm) => {
          if (vm.paymentRequired === false) {
            return true
          }
          return value === false
        }
      },
      autoTopUp: {
        validType: (value, vm) => {
          return value.type !== null
        }
      }
    }
  },
  computed: {
    ...mapGetters('activation/payment', {
      paymentContext: 'paymentContext',
      storedPayment: 'payment'
    }),
    ...mapGetters('activation/topUp', {
      storedTopUp: 'topUp'
    }),
    paymentRequired: function () {
      return this.autoTopUp.type !== 'withoutAuto'
    },
    fullNameAccountOwner () {
      return this.paymentContext.firstName + ' ' + this.paymentContext.lastName
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/payment', [
      'validateAndSavePayment'
    ]),
    ...mapActions('activation/submit', [
      'activationInitiate'
    ]),
    back () {
      this.goToStep(this.previousStep)
    },
    async save () {
      this.loading = true
      this.payment.owner = this.fullNameAccountOwner
      await this.validateAndSavePayment({ paymentData: this.payment, topUpData: this.autoTopUp, nextStep: stepName })
      await this.activationInitiate()
      this.goToStep(this.nextStep)
      this.loading = false
    }
  },
  components: { PaymentWrapper, ActivationAutoTopUpWrapper },
  props: {
    creditCardFrameAddress: {
      type: String
    },
    creditCardRedirectUrl: {
      type: String
    },
    monthlyValue: {
      type: Array
    }
  }
}
</script>
